// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/fa6481ac19a6e5189ad5.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"c0329e726a781d0a5efa","122":"247f5e58e430655c6e5f","123":"64c52e618f0bd687ed94"}[chunkId] + ".chunk.js";
};